import { useState, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useAddBundlesReturn, BundleType } from '../../model/bundles.model'
import { setSelectedBundles } from '../../store/bundles.reducer'
import { selectSelectedBundlesIds } from '../../store/bundles.selectors'

import { RootState } from '~/core/store/root.reducer'
import { selectBundlesListWithPrice } from '~/prices/prices.selectors'

export default function useAddBundle(
  lineId: string,
  type: BundleType,
  setAddBundle: (value: boolean) => void,
  preselected?: number,
): useAddBundlesReturn {
  const [selected, setSelected] = useState(preselected || 0)

  const dispatch = useDispatch()

  const selectedBundles = useSelector((state: RootState) =>
    selectSelectedBundlesIds(state, lineId, type),
  )

  const bundlesList = useSelector((state: RootState) =>
    selectBundlesListWithPrice(state, lineId, type),
  )

  const onSelectBundles = useCallback(
    (id: number) => {
      const list = selectedBundles.filter((elem) => elem !== selected)
      const bundles = [...list, id]
      dispatch(setSelectedBundles({ id: lineId, bundles, type }))
    },
    [selectedBundles],
  )

  const availableBundles = useMemo(() => {
    const list = bundlesList.filter((bundle) => {
      const isSelected = !!selectedBundles.find((bundleId) => bundleId === bundle.id)
      return !isSelected
    })

    const selectedBundle = bundlesList.find((elem) => elem.id === selected)

    return selectedBundle ? [selectedBundle] : list
  }, [bundlesList, selectedBundles, selected])

  function onSelect(id: number) {
    onSelectBundles(id)
    setSelected(id)
    setAddBundle(false)
  }

  return { onSelect, availableBundles, selected }
}
